import { Spinner } from '@/components/spinner/spinner';
import { cn } from '@/libs/shadcn';

interface SuspenseFallbackProps {
  containerClassName?: string;
  spinnerClassName?: string;
}
export default function SuspenseFallback({
  containerClassName,
  spinnerClassName,
}: SuspenseFallbackProps) {
  return (
    <div
      className={cn(
        'flex flex-col overflow-hidden h-screen justify-center items-center',
        containerClassName
      )}
    >
      <Spinner className={cn('size-12', spinnerClassName)} />
    </div>
  );
}
